import React, { Fragment} from 'react';
import Header from '../Header/Header'
import styles from '../NavBar/NavBar.module.css'
const Loading=()=>{
    return (
        <Fragment>
            <Header></Header>
            <div className={styles.container}>
                <div style={{"padding":"20px", "fontSize":"18px"}}>
                    Please wait while we take you to the site ..
                </div>
            </div>
        </Fragment>
    )
}

export default Loading;